import { EditBase, Form } from "ra-core";
import { Card, CardContent } from "@/components/ui/card";

import { FormToolbar } from "../layout/FormToolbar";
import { GroupInputs } from "./GroupInputs";

export const GroupEdit = () => (
  <EditBase redirect="list">
    <div className="mt-2 flex max-w-md">
      <Form className="flex-1">
        <Card>
          <CardContent>
            <GroupInputs />
            <FormToolbar />
          </CardContent>
        </Card>
      </Form>
    </div>
  </EditBase>
);
